import LazyImg from 'App/Components/LazyImg';

import './styles.scss';

/**
 * HowPlayCard renders one illustrated step in the “How to play” section.
 * It shows a football image and a tilted copy card. A left-aligned step
 * wraps the image so it sits on the opposite side.
 *
 * @param {string} image — Football illustration source.
 * @param {string} imageAlt — Accessible label for the football image.
 * @param {string} cardImage — Decorative card background (left or right variant).
 * @param {string} cardImageAlt — Accessible label for the card background.
 * @param {string} text — Step copy shown on the card.
 * @param {'left' | 'right'} align — Which side the copy card sits on.
 * @param {'top' | 'center' | 'bottom'} imageClass — Position modifier for the football image.
 * @param {'1' | '2' | '3'} textClass — Position modifier for the copy block.
 */

export const HowPlayCard = ({
    image,
    imageAlt,
    cardImage,
    cardImageAlt,
    text,
    align,
    imageClass,
    textClass,
}) => {
    const media = (
        <div className={`how-play-card__media how-play-card__media--${imageClass}`}>
            <LazyImg src={image} rootMargin='70px' width={785} height={594} alt={imageAlt} />
        </div>
    );

    return (
        <div className='how-play-card'>
            {align === 'left' ? <div className='how-play-card__media-wrap'>{media}</div> : media}

            <div className={`how-play-card__description how-play-card__description--${align}`}>
                <div className='how-play-card__body'>
                    <div className='how-play-card__picture'>
                        <LazyImg
                            src={cardImage}
                            rootMargin='70px'
                            width={379}
                            height={505}
                            alt={cardImageAlt}
                        />
                    </div>

                    <div className={`how-play-card__text how-play-card__text--${textClass}`}>
                        <p>{text}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
